import React from 'react';
import { Plus, Mail } from 'lucide-react';

import { FAQ_ITEMS } from '../landingPageData';
import css from './FAQ.module.css';

const FAQ = () => {
  return (
    <section className={css.section} id="faq">
      <div className={css.container}>
        <div className={css.grid}>
          <div className={css.headCol}>
            <span className={css.overline}>FAQ</span>
            <h2 className={css.title}>Common questions, real answers.</h2>
            <p className={css.sub}>
              The questions hiring companies and providers ask us most. If yours isn't here, reach
              out and we'll get back to you.
            </p>
            <div className={css.contact}>
              <div className={css.contactTitle}>Still have questions?</div>
              <a className={css.contactLink} href="mailto:hello@whitelabelexperts.com">
                <Mail className={css.contactIcon} />
                hello@whitelabelexperts.com
              </a>
            </div>
          </div>

          <div className={css.list}>
            {FAQ_ITEMS.map((item, i) => (
              <details key={item.q} className={css.item} open={i === 0}>
                <summary className={css.summary}>
                  {item.q}
                  <span className={css.chev}>
                    <Plus className={css.chevIcon} />
                  </span>
                </summary>
                <div className={css.answer}>{item.a}</div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
